<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="userSearch.name"
    @on-confirm="advsearch"
    @on-cancel="hide()"
    :okText="$t('Search')"
    :closeText="$t('Close')"
    maxWidth="60%"
  >
    <div v-for="item in conditionItems" :key="item.uuid">
      <SearchCriteriaCondition
        :ref="`searchCriteriaConditionKey${item.uuid}`"
        :fieldList="fieldList"
        :showAddButton="false"
        :disableFieldSelect="true"
        :disableSearchOperatorSelect="false"
        :conditionItem="item"
        v-if="item.isLogicalOperator == false"
        :clearValue="false"
      />
    </div>
  </base-modal>
</template>

<script>
import SearchCriteriaCondition from "@/components/search/SearchCriteriaCondition.vue";
import SearchService from "@/services/SearchService";
import ConditionItem from "@/ecm/models/search/ConditionItem";
import UserSearch from "@/ecm/models/UserSearch";
import SearchType from "@/ecm/variables/SearchType";
import SearchConstValues from "@/ecm/variables/SearchConstValues";

export default {
  name: "ParamSearchModal",
  components: {
    SearchCriteriaCondition,
  },
  data() {
    return {
      modal: {
        key: "paramSearchModal",
      },
      userSearch: new UserSearch(),
      open: false,
      conditionItems: [],
      fieldList: [],
    };
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modal.key];
    },
  },
  methods: {
    async getFields() {
      var standardFields = this.$store.getters["account/searchStandardFields"];
      if (this.userSearch.contentTypeIDs != "") {
        var fields = await SearchService.getAdvSearchFields(
          this.userSearch.contentTypeIDs.join()
        );
        return [...fields, ...standardFields];
      } else {
        return standardFields;
      }
    },
    advsearch() {
      var condition = "";
      if (this.conditionItems.length > 0) {
        condition = this.conditionItems
          .map((item) => item.conditionStr())
          .join(";");
      }
      if (condition == "") {
        return;
      }
      var pattern = {
        contentTypeIDs: this.userSearch.contentTypeIDs.join(","),
        searchPattern: condition,
        searchAllVersions: this.userSearch.searchAllVersions,
      };
      this.modalInstance.progress(true);
      var route = "/search/";
      route += `${SearchType.AdvancedSearch}/${encodeURIComponent(
        JSON.stringify(pattern)
      )}`;
      this.$router.push(route);
      this.modalInstance.progress(false);
      this.hide();
    },
    setConditionItemDisplayValues(conditionItem) {
      var field = this.fieldList.find((x) => x.Code == conditionItem.fieldCode);
      if (field) {
        conditionItem.fieldTitle = field.Title;
      }
      var searchOperator = this.$store.getters["account/searchOperators"].find(
        (x) => x.Code == conditionItem.searchOperatorCode
      );
      if (searchOperator) {
        conditionItem.searchOperatorTitle = searchOperator.Title;
      }
      if (conditionItem.fieldValue == SearchConstValues.Today) {
        conditionItem.fieldDisplayValue = this.$t("Today");
      } else if (conditionItem.fieldValue == SearchConstValues.Myself) {
        conditionItem.fieldDisplayValue = this.$t("Myself");
      } else if (
        conditionItem.fieldValue == SearchConstValues.Empty ||
        conditionItem.fieldValue == SearchConstValues.NotEmpty
      ) {
        conditionItem.fieldValue = "";
      } else if (conditionItem.fieldDisplayValue == SearchConstValues.Myself) {
        conditionItem.fieldValue = this.$t("Myself");
      } else {
        conditionItem.fieldDisplayValue = conditionItem.fieldValue
          .replace(
            SearchConstValues.DaysBeforeToday,
            `${this.$t("DaysBeforeToday")} ${this.$t("Today")}`
          )
          .replace(
            SearchConstValues.DaysAfterToday,
            `${this.$t("DaysAfterToday")} ${this.$t("Today")}`
          );
      }
    },
    async edit(dto) {
      this.userSearch = new UserSearch(dto);
      this.fieldList = await this.getFields();
      this.conditionItems = [];
      this.userSearch.conditionStr.split(";").forEach((condition) => {
        var conditionItem = new ConditionItem(condition);
        this.setConditionItemDisplayValues(conditionItem);
        this.conditionItems.push(conditionItem);
      });
      this.show();
    },
    show() {
      this.open = true;
    },
    hide() {
      this.open = false;
    },
  },
};
</script>